import axios from "axios";
import {authorizationServicesPath} from "../../Constants";

const restUrl = authorizationServicesPath + "/customers/customer-user-entity"

export default class CustomerUserEntity {
    static async getAll() {
        return axios.get(restUrl + "/own");
    }

    /** GET профиля для вкладки реквизитов: паспорт, address, residentialAddress. */
    static async getOwnForComposition() {
        return axios.get(restUrl + "/own-for-composition");
    }

    /** PATCH персональных полей (без адресов). */
    static async edit(data) {
        return axios.patch(restUrl + "/own", JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getByCustomer() {
        return axios.get(restUrl + "/by-customer", {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(id, data) {
        return await axios.patch(restUrl + '/by-customer/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateUnable(id, status) {
        await axios.patch(restUrl + "/" + id + '/unable?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(restUrl + "?email=" + data, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/by-customer/' + id);
    }
}